<template>
  <div :class="[{ show: showDialog }]" class="theme__popup" v-click-outside="forceClose">
    <button
      type="button"
      style="margin: auto; display: flex; flex-direction: column"
      class="open-btn"
      @click="onClickOpen"
    >
      <div class="theme__list-row-coverage-percent">{{ percentage }}%</div>
      <div v-if="!hasFilter" class="theme__list-row-coverage-num-responses">
        {{
          `(${parsedCoverage} /
          ${sortedResponsesLength})`
        }}
      </div>
      <div v-if="hasFilter" class="theme__list-row-coverage-num-responses">
        {{
          `(${parsedFilteredCoverage} /
                      ${sortedResponsesLength})`
        }}
      </div>
    </button>
    <DialogPopup
      class="theme__popup-dialog"
      :class="isThemelist == true ? 'theme__popup-dialog-left' : ''"
      header-tag="h4"
      :show="showDialog"
      @close="showDialog = false"
      v-if="Object.keys(numeratorDetails).length > 0"
      style="width: 30rem"
    >
      <template #header>
        <div
          style="
            display: flex;
            flex-direction: row;
            text-align: left;
            font-size: 1rem;
            text-transform: none;
          "
        >
          Coverage for the theme:
        </div>
        <span
          class="theme__popup-dialog-name"
          style="
            font-family: Core-Sans;
            text-align: left;
            font-size: 1rem;
            text-transform: none;
            margin-left: 0.5rem;
            text-decoration: none;
          "
          >&nbsp;{{ theme.name }}</span
        >
      </template>
      <template #body>
        <div v-if="theme">
          <div v-if="!theme.coverage.total || (hasFilter && !theme?.filtered_coverage.total)">
            <VisibleText>No matches</VisibleText>
          </div>
          <div
            style="
              text-align: left;
              display: flex;
              flex-direction: column;
              text-transform: none;
              padding-left: 0.5rem;
            "
          >
            <div v-if="numeratorDetails.total" style="display: flex">
              The total of&nbsp;{{ numeratorDetails.total }} unique text entries comes from:
            </div>
            <div style="display: flex; flex-direction: column">
              <div v-if="numeratorDetails.matched_by_keyword">
                <span class="signal positive">+</span
                >{{ numeratorDetails.matched_by_keyword }} &nbsp;have at least one keyword match
              </div>
              <div v-if="numeratorDetails.human_dropped">
                <span class="signal negative">-</span
                >{{ numeratorDetails.human_dropped }} &nbsp;have keyword matches but ignored by a
                human
              </div>
              <div v-if="numeratorDetails.ml_dropped">
                <span class="signal negative">-</span>{{ numeratorDetails.ml_dropped }} &nbsp;have
                keyword matches but ignored by machine learning
              </div>
              <div v-if="numeratorDetails.matched_by_human_notes">
                <span class="signal positive">+</span
                >{{ numeratorDetails.matched_by_human_notes }} &nbsp;have unique human note matches
              </div>
              <div v-if="numeratorDetails.matched_by_ml_notes">
                <span class="signal positive">+</span
                >{{ numeratorDetails.matched_by_ml_notes }} &nbsp;have unique ML-note matches
              </div>
              <div v-if="numeratorDetails.overlapping_notes">
                <span class="signal neutral"></span
                >{{ numeratorDetails.overlapping_notes }} &nbsp;have overlapping notes that do not
                count towards the total
              </div>
            </div>
          </div>
        </div>
      </template>
      <template #footer>
        <div
          style="display: flex; padding-left: 1rem"
          v-if="hasPreProcessedText && includeSmartCoverage == 'include'"
        >
          <VisibleText
            >Smart search on. Including keyword matches across tenses and plural/singular
            form.</VisibleText
          >
        </div>
      </template>
    </DialogPopup>
  </div>
</template>

<script>
import DialogPopup from '@/components/UI/DialogPopup.vue';

export default {
  name: 'CoveragePopup',
  components: {
    DialogPopup,
  },
  props: {
    sortedResponsesLength: {
      type: Number,
      required: false,
      default: () => 0,
    },
    isThemelist: {
      default: () => false,
      type: Boolean,
    },
    index: {
      default: () => -1,
      type: Number,
    },
    theme: {
      default: () => {},
      type: Object,
    },
    hasPreProcessedText: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    includeSmartCoverage: {
      type: String,
      default: () => 'exclude',
    },
    hasFilter: {
      type: Boolean,
      required: false,
      default: () => false,
    },
  },
  data() {
    return {
      showDialog: false,
      numeratorDetails: {},
    };
  },
  created() {
    this.updateDetails();
  },
  computed: {
    parsedCoverage() {
      if (this.theme.coverage.total > -1) {
        return this.theme.coverage.total;
      }
      return 0;
    },
    parsedFilteredCoverage() {
      if (this.theme?.filtered_coverage?.total >= 0) {
        return this.theme?.filtered_coverage?.total;
      }
      return -1;
    },
    percentage() {
      let percentage = 0;
      if (this.hasFilter) {
        percentage = (this.parsedFilteredCoverage / this.sortedResponsesLength) * 100;
        return percentage.toFixed(1);
      }
      percentage = (this.parsedCoverage / this.sortedResponsesLength) * 100;
      return percentage.toFixed(1);
    },
  },
  methods: {
    updateDetails() {
      if (this.hasFilter && this.theme.filtered_coverage) {
        this.numeratorDetails = this.theme.filtered_coverage;
      } else {
        this.numeratorDetails = this.theme.coverage;
      }
    },
    offsetByPage(index) {
      return (this.pagination.page - 1) * this.pagination.limit + index;
    },
    forceClose() {
      if (this.showDialog) this.showDialog = false;
    },
    onClickOpen() {
      if (this.theme) {
        this.showDialog = true;
      }
    },
  },
  watch: {
    // parsedCoverage: async function () {
    //   this.updateDetails();
    // },
    // parsedFilteredCoverage: async function () {
    //   this.updateDetails();
    // },
    theme: async function () {
      this.updateDetails();
    },
  },
};
</script>

<style scoped>
.theme__popup-dialog {
  max-width: 32rem;
  width: calc(100% * 3);
}

.signal {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  margin-right: 6px;
  font-size: 0.8rem;
  font-weight: 700;
}

.signal.positive {
  color: #16a34a; /* green-600 */
  font-size: 1.2rem;
}

.signal.negative {
  color: #dc2626; /* red-600 */
  font-size: 1.2rem;
}
.signal.neutral {
  font-size: 1.2rem;
}
</style>
